import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rt-progress',
  styleUrls: ['./progress.component.less'],
  templateUrl: './progress.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.solid-background]': 'solidBackground',
  },
  standalone: true,
})
export class ProgressComponent {
  @Input() public percents: number = 0;
  @Input() public height: number = 0.8;
  @Input() public isFullWidth: boolean = false;
  @Input() public solidBackground: boolean = false; // use background color without opacity
  @Input() public progressBarBorderRadius = true;
  @Input() public noProgressContainerTopBorderRadius = false;
  @Input() public noProgressContainerBottomBorderRadius = false;
  @Input() public noProgressBarBoxShadow = false;
}
